import React from 'react'
import PropTypes from 'prop-types'
import { Collapse, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from '@material-ui/core'
import { currencyFormat } from '../../../../store/helpers/AmountHelper'

const SerieDetail = (props) => {
	const { equipmentItem, service } = props
	const { isOpen } = props
	if (!isOpen) return null

	console.log('service in PaymentDetailsComponent=', equipmentItem)
	console.log('service in PaymentDetailsComponent=', equipmentItem)

	let allPaidServices = service?.PaidServices.filter((x) => x.Equipments && x.Equipments.some((equip) => equip.Serie === equipmentItem?.Serie))
	console.log('allPaidServices=', allPaidServices)

	// // Obtener todos los equipments del servicio
	// // const equipments = allPaidServices || []

	// const formatFolio = (ticket) => {
	// 	// Si necesitas un formato específico como PR-0005457
	// 	return ticket ? `PR-${ticket.padStart(7, '0')}` : 'N/A'
	// }

	// // Mapear equipments a formato de tabla con sus datos
	// const ticketData = allPaidServices.map((paidService) => {
	// 	// Calcular el total de ServiceAmounts para este servicio
	// 	const totalAmount = paidService?.TotalAmounts?.reduce((acc, amount) => acc + (amount.Amount || 0), 0) || 0

	// 	return {
	// 		Folio: formatFolio(paidService?.Ticket) || 'N/A',
	// 		CreationDate: paidService?.CreationDate || 'N/A',
	// 		Ticket: paidService?.Ticket || 'N/A',
	// 		SubCategory: paidService?.Subcategory || 'N/A',
	// 		ServiceProvider: paidService?.ServiceProvider?.Name || 'N/A',
	// 		TotalAmount: totalAmount,
	// 		EquipmentToken: paidService.Token
	// 	}
	// })

	// Calcular el gran total de todos los registros
	// const grandTotal = ticketData.reduce((acc, ticket) => acc + (ticket.TotalAmount || 0), 0).toFixed(2)
	const getTotalAmountsSum = () => {
		if (!allPaidServices || allPaidServices.length === 0) return 0
		return allPaidServices.reduce((sum, payment) => sum + (Number(payment.TotalAmounts) || 0), 0)
	}
	return (
		<Collapse in={isOpen} timeout='auto' unmountOnExit>
			<Box
				style={{
					margin: '8px 16px 16px 16px',
					padding: '12px',
					backgroundColor: '#f9f9f9',
					borderRadius: '4px',
					border: '1px solid #e0e0e0'
				}}
			>
				{/* Título */}
				<Typography variant='h6' gutterBottom>
					Payments
				</Typography>
				<TableContainer component={Paper} elevation={0} style={{ backgroundColor: 'white' }}>
					<Table size='small'>
						<TableHead>
							<TableRow style={{ backgroundColor: '#f5f5f5' }}>
								<TableCell>
									<strong>Folio</strong>
								</TableCell>
								<TableCell>
									<strong>Creation Date</strong>
								</TableCell>
								<TableCell>
									<strong>Ticket</strong>
								</TableCell>
								<TableCell>
									<strong>SubCategory</strong>
								</TableCell>
								<TableCell>
									<strong>Service Provider</strong>
								</TableCell>
								<TableCell align='right'>
									<strong>Total Amounts</strong>
								</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{allPaidServices.length > 0 ? (
								<>
									{allPaidServices.map((paidService, index) => (
										<TableRow key={paidService.EquipmentToken || index} hover>
											<TableCell>{paidService.PaymentFolio}</TableCell>
											<TableCell>{paidService.CreationDate}</TableCell>
											<TableCell>{paidService.Ticket}</TableCell>
											<TableCell>{paidService.Subcategory}</TableCell>
											<TableCell>{paidService.ServiceProvider}</TableCell>
											<TableCell align='right'>{`${currencyFormat(paidService.TotalAmounts)}`}</TableCell>
										</TableRow>
									))}
									{/* Fila con total */}
									<TableRow style={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>
										<TableCell colSpan={5} align='right'>
											<strong>Total</strong>
										</TableCell>
										<TableCell align='right'>
											<strong>{currencyFormat(getTotalAmountsSum())}</strong>
										</TableCell>
									</TableRow>
								</>
							) : (
								<TableRow>
									<TableCell colSpan={6} align='center'>
										<Typography variant='body2' color='textSecondary'>
											No payment data available
										</Typography>
									</TableCell>
								</TableRow>
							)}
						</TableBody>
					</Table>
				</TableContainer>
			</Box>
		</Collapse>
	)
}

SerieDetail.propTypes = {
	serie: PropTypes.shape({
		Token: PropTypes.string.isRequired,
		Serie: PropTypes.string.isRequired,
		WarrantyStatus: PropTypes.string.isRequired,
		Model: PropTypes.string.isRequired,
		ServiceType: PropTypes.number,
		WarrantyChecks: PropTypes.array,
		TicketServicesIncludes: PropTypes.string,
		CreationDate: PropTypes.string,
		FaultWarranty: PropTypes.string
	}).isRequired,
	isOpen: PropTypes.bool.isRequired,
	service: PropTypes.shape({
		Token: PropTypes.string,
		CreationDate: PropTypes.string,
		Ticket: PropTypes.string,
		Subcategory: PropTypes.string,
		Status: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		TotalAmounts: PropTypes.number,
		ServiceProvider: PropTypes.shape({
			Name: PropTypes.string
		}),
		ServiceAmounts: PropTypes.arrayOf(
			PropTypes.shape({
				Token: PropTypes.string,
				Description: PropTypes.string,
				Amount: PropTypes.number
			})
		),
		Equipments: PropTypes.array
	})
}

export default SerieDetail
